import React from 'react'; 
import { Container, Header } from 'semantic-ui-react'
import './../assets/eje.css';
import auth0Client from './Auth/Auth'; 

export default class Inicio extends React.Component {
  
    constructor(props) {
        super(props);
        this.state = { 
          
        };
    }

    componentDidMount() {
        auth0Client.isExpired();
    }

    render() {

        console.log('bienvenido');

        return (
          <Container text>
  
              <Header as='h1' textAlign='center' className='h2'>SISTEMA EXPERTO</Header>
             
          </Container>
        );
    }
}